<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>基础配置</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/admin/baseContent/indexBanner' }"
          >轮播图列表
        </el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">轮播图信息</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <span class="font-weight-bold text-primary">配置轮播图信息</span>
      </div>
      <div style="height: 470px;overflow-y: auto;padding-right: 60px">
        <el-form
          :model="bannerInfo"
          label-width="120px"
          class="font-weight-bold w-75"
        >
          <el-form-item label="游戏名称">
            <el-select
              v-model="bannerInfo.gameId"
              filterable
              placeholder="请选择游戏"
            >
              <el-option
                v-for="item in gameList"
                :key="item.gameId"
                :label="item.gameName"
                :value="item.gameId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-radio-group v-model="bannerInfo.status">
              <el-radio :label="true" border>激活</el-radio>
              <el-radio :label="false" border>禁用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="排序">
            <el-input
              v-model="bannerInfo.bannerOrder"
              placeholder="展示顺序，数字越小越靠前"
            ></el-input>
          </el-form-item>
          <el-form-item label="轮播图">
            <el-input
              v-model="bannerInfo.imgUrl"
              autocomplete="off"
              placeholder="轮播图URL"
            >
            </el-input>
            <div class="d-flex">
              <img-upload @onUpload="uploadImg" ref="imgUpload"></img-upload>
              <small class="text-muted ml-3">推荐图片尺寸1500*600像素</small>
            </div>
            <div class="mt-2">
              <el-image
                class="img-thumbnail text-muted"
                :src="bannerInfo.imgUrl"
                :preview-src-list="[bannerInfo.imgUrl]"
              />
            </div>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitBannerForm(bannerInfo)"
              >立即提交
            </el-button>
            <el-button @click="cancelSubmitForm()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<!--suppress JSUnresolvedVariable -->
<script>
import ImgUpload from "../../components/common/ImgUpload";

export default {
  name: "BannerForm",
  data() {
    return {
      bannerId: this.$route.params.bannerId,
      bannerInfo: {
        imgUrl: ""
      },
      gameList: []
    };
  },
  components: {
    ImgUpload
  },
  mounted() {
    if (this.bannerId !== 0) {
      this.getBannerById();
    }
    this.getGameList();
  },
  methods: {
    getBannerById() {
      this.axios
        .get("/banner/getBannerById", {
          params: {
            bannerId: this.bannerId
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.bannerInfo = resp.data.data;
          }
        });
    },
    uploadImg() {
      this.bannerInfo.imgUrl = this.$refs.imgUpload.url;
    },
    getGameList() {
      this.axios.get("/game/getAllGame").then(resp => {
        if (resp && resp.data.code === 10000 && resp.data.success) {
          this.gameList = resp.data.data;
        }
      });
    },
    cancelSubmitForm() {
      this.$router.push({ name: "IndexBanner" }).catch();
    },
    submitBannerForm(bannerInfo) {
      this.axios
        .post("/banner/admin/addOrUpdateBanner", {
          bannerId: bannerInfo.bannerId,
          gameId: bannerInfo.gameId,
          gameName: bannerInfo.gameName,
          imgUrl: bannerInfo.imgUrl,
          status: bannerInfo.status,
          bannerOrder: bannerInfo.bannerOrder
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.$router.push({ name: "IndexBanner" }).catch();
          } else {
            this.$notify.error({
              title: "错误",
              message: "操作失败！"
            });
          }
        });
    }
  }
};
</script>

<style scoped></style>
